import { render, staticRenderFns } from "./ContractDetail.vue?vue&type=template&id=2786be0e&scoped=true"
import script from "./ContractDetail.vue?vue&type=script&lang=ts"
export * from "./ContractDetail.vue?vue&type=script&lang=ts"
import style0 from "./ContractDetail.vue?vue&type=style&index=0&id=2786be0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2786be0e",
  null
  
)

export default component.exports